import { newId } from '@/utils.js'
import { db, Timestamp } from '@/firebase.js'
import { firestoreAction } from 'vuexfire'
import { DateTime } from 'luxon'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  logs(state) {
    return Object.assign({}, ...state.data.map((i) => ({ [i.id]: i })))
  },
  logById(state, getters) {
    return (id) => {
      try {
        return getters['logs'][id]
      } catch {
        return null
      }
    }
  },
  monthlyLog(state, getters, rootState, rootGetters) {
    try {
      const monthlyLogId = rootGetters['storeModule/monthlyLog']
      return monthlyLogId ? getters['logs'][monthlyLogId] : null
    } catch {
      return null
    }
  },
  weeklyLog(state, getters, rootState, rootGetters) {
    try {
      const weeklyLogId = rootGetters['storeModule/weeklyLog']
      return weeklyLogId ? getters['logs'][weeklyLogId] : null
    } catch {
      return null
    }
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  bindStore: firestoreAction(
    ({ bindFirestoreRef, commit, state }, { storeId }) => {
      commit('setRef', db.collection('stores').doc(storeId).collection('logs'))
      return bindFirestoreRef(
        'data',
        state.ref.where(
          'date',
          '>=',
          DateTime.now().minus({ days: 30 }).toJSDate()
        )
      )
    }
  ),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function ({ getters }, payload) {
    let id = newId()
    let data = {
      date: Timestamp.now(),
      createdAt: Timestamp.now(),
      status: 'open',
      completed: false,
      id,
      ...payload
    }
    console.log('logs/create', id, data)
    return await getters.ref
      .doc(id)
      .set(data)
      .then(() => id)
      .catch((err) => err)
  },
  updateItem({ getters }, { id, data }) {
    console.log('logs/updateItem', id, data)
    return getters.ref.doc(id).update(data)
  },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const logs = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}

export default logs
